import { ReactWrapper } from '@components'

import { DemoComponent } from './DemoComponent'

export default ReactWrapper(DemoComponent, 'reactDemoComponent')
